import React from 'react';
import { Button, Icon } from '@perch-labs/shrike';
import { copyFor, config } from 'config';
import { MAX_NAV_WIDTH } from 'domain/style';
import { Grid, GridCell, Container } from 'styles';

const getCopy = copyFor('navigation.backButton');

interface Props {
  previousRoute: string;
  onClick: () => void;
}

export const BackButton = ({ previousRoute, onClick }: Props) => {
  const location = getCopy(
    `locations.${
      previousRoute as keyof typeof config.copy.navigation.backButton.locations
    }`
  );

  return (
    <Grid maxWidth={MAX_NAV_WIDTH} margin="auto">
      <GridCell columnStart={2} height="100%" small={{ columnStart: 1 }}>
        <Container
          margin={{ bottom: '8px', left: '12px', top: '32px' }}
          small={{ margin: { left: '24px', top: '24px' } }}
        >
          <Button
            aria-label={getCopy('ariaLabel', { location })}
            backgroundless={true}
            onClick={onClick}
            size="small"
          >
            <Icon margin={{ right: '8px' }} icon="ChevronLeft" />
            {getCopy('button')}
          </Button>
        </Container>
      </GridCell>
    </Grid>
  );
};
